import { breakpoints, colors } from "@brightagency/headstart-common";
import { transparentize } from "polished";
import styled, { css } from "styled-components";

export const Outer = styled.div<{ hasListings: boolean }>`
    background-color: ${colors.brandMid};
    padding: 25px 0;

    ${breakpoints.large} {
        ${({ hasListings }) =>
            hasListings
                ? css`
                      padding: 40px 0 0;
                  `
                : css`
                      padding: 70px 0;
                  `}
    }
`;

export const Inner = styled.div`
    margin-bottom: 16px;

    ${breakpoints.large} {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 24px;
    }
`;

export const TextContent = styled.div`
    text-align: left;
    ${breakpoints.large} {
        padding-right: 30px;
    }
`;

export const TitleSecondarySection = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 24px;
    width: 100%;

    ${breakpoints.large} {
        justify-content: space-between;
    }
`;

export const SortButtonWrapper = styled.div`
    margin-right: 0;
    width: 100%;
    text-align: left;

    ${breakpoints.large} {
        margin-right: 24px;
    }

    .carousel-wrapper{
        background-color: transparent;
        padding: 0;

        .carousel-container{
            padding: 0 !important;
        }
        .carousel-item{
            ${breakpoints.small} {
                width: auto !important;
            }
        }
    }
`;

export const Title = styled.h1`
    color: white;
    font-size: 28px;
    text-align: center;

    ${breakpoints.large} {
        font-size: 40px;
    }
`;

export const SubTitle = styled.h3`
    color: white;
    padding-bottom: 0;
    margin-bottom: 0;
    margin-top: 0;
    font-size: 25px;

    ${breakpoints.medium} {
        font-size: 32px;
    }
`;

export const Skeleton = styled.div`
    padding-bottom: 140%;
    background-color: ${transparentize(0.8, "white")};
    border-radius: 20px;
`;
